<template>
  <request :method="request.method" :params="request.params" #default="{ loading, error }" v-model="response">
    <content-spinner v-if="loading" class="ma3"/>
    <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
    <div v-else-if="history && history.length > 0" class="entity-details-layout entity-details-layout-list">
      <icon-in-circle class="entity-details-icon">
        <font-awesome-icon icon="history"/>
      </icon-in-circle>
      <div class="entity-details-header pv3 pv4-l ph3 ph1-l">
        <span class="db ttu f6 fw6 entity-secondary">История изменения статусов</span>
      </div>
      <div class="entity-details-content list-grid ml4-l bt b--near-white bw1">
        <journal-list-item v-for="(item, index) in history" :key="index" :item="item" :showClaim="false" />
      </div>
    </div>
    <div v-else class="ph3 pv4 entity-secondary">
      журнал пуст
    </div>
  </request>
</template>

<script>
import Request from '@/components/Request.vue'
import ContentSpinner from '@/components/ui/progress/ContentSpinner.vue'
import IconInCircle from '@/components/ui/IconInCircle.vue'
import JournalListItem from '@/components/claims/JournalListItem.vue'
import { mapGetters } from 'vuex'

export default {
  props: ['claim'],
  components: {
    Request,
    ContentSpinner,
    IconInCircle,
    JournalListItem
  },
  computed: {
    ...mapGetters('session', ['user']),
    request () {
      return {
        method: 'getClaimsLogs',
        params: {
          companyId: this.user.companyId,
          claimId: this.claim.id,
          offset: 0,
          limit: 10
        }
      }
    },
    history () {
      return this.response && this.response.claimLogs
        ? this.response.claimLogs
        : []
    }
  },
  data: () => ({
    response: null
  })
}
</script>

<style lang="scss" scoped>
</style>
